import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  grid-area: header;\n'], ['\n  grid-area: header;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 350px 1fr;\n\n  @media (max-width: ', ') {\n    grid-template-columns: 250px 1fr;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 350px 1fr;\n\n  @media (max-width: ', ') {\n    grid-template-columns: 250px 1fr;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 15px;\n  text-transform: uppercase;\n  letter-spacing: 1.13px;\n  margin-bottom: 15px;\n\n  @media (max-width: ', ') {\n    font-size: 12px;\n  }\n'], ['\n  font-size: 15px;\n  text-transform: uppercase;\n  letter-spacing: 1.13px;\n  margin-bottom: 15px;\n\n  @media (max-width: ', ') {\n    font-size: 12px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 24px;\n  line-height: 1.1;\n  margin-bottom: 15px;\n  letter-spacing: -0.25px;\n\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n'], ['\n  font-size: 24px;\n  line-height: 1.1;\n  margin-bottom: 15px;\n  letter-spacing: -0.25px;\n\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  text-align: right;\n  font-size: 24px;\n  line-height: 1.1;\n  letter-spacing: -0.25px;\n\n  ', '\n  \n    @media (max-width: ', ') {\n    font-size: 18px;\n  }\n'], ['\n  text-align: right;\n  font-size: 24px;\n  line-height: 1.1;\n  letter-spacing: -0.25px;\n\n  ', '\n  \n    @media (max-width: ', ') {\n    font-size: 18px;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n      color: ', ';\n    '], ['\n      color: ', ';\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: ', ';\n  margin-right: 6px;\n'], ['\n  color: ', ';\n  margin-right: 6px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: ', ';\n  margin-left: 6px;\n'], ['\n  color: ', ';\n  margin-left: 6px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 1.3;\n  margin: 5px 0 0 0;\n  max-width: 300px;\n'], ['\n  color: ', ';\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 1.3;\n  margin: 5px 0 0 0;\n  max-width: 300px;\n']);

import styled, { css } from 'styled-components';

export var HeaderGridDiv = styled.div(_templateObject);

export var StyledHeaderContainer = styled.div(_templateObject2, function (props) {
  return props.theme.mobileWidth;
});

export var StyledVendor = styled.div(_templateObject3, function (props) {
  return props.theme.mobileWidth;
});

export var StyledH1 = styled.h1(_templateObject4, function (props) {
  return props.theme.mobileWidth;
});

export var StyledPriceWrapper = styled.div(_templateObject5, function (_ref) {
  var isSale = _ref.isSale;
  return isSale && css(_templateObject6, function (_ref2) {
    var theme = _ref2.theme;
    return theme.dormifyPink;
  });
}, function (props) {
  return props.theme.mobileWidth;
});

export var StyledCompareAtPrice = styled.span(_templateObject7, function (props) {
  return props.theme.dormifyBlack;
});

export var StyledCompareAtPercentOff = styled.span(_templateObject8, function (props) {
  return props.theme.dormifyPink;
});

export var StyledFinalSaleText = styled.p(_templateObject9, function (props) {
  return props.theme.dormifyBoulder;
});